/**
 * Вход приложения — и больше ничего.
 *
 * Здесь нет ни одного статического импорта оболочки, и это единственное, чем
 * файл занят. Заслон (`public/support.js`, ADR-0106) успевает отработать до
 * модулей, но отменить их загрузку не может: модуль подключён в разметке.
 * Значит граница проходит не по «скачано», а по «начало работать» — а начать
 * работу импорт успел бы сам, до первой строки тела.
 *
 * Обещание тут ровно одно: браузер ниже минимума не откроет базу и не покажет
 * оболочку поверх сообщения, которое ему уже нарисовали.
 */
declare global {
  // eslint-disable-next-line no-var
  var tervikUnsupported: string | undefined
  /**
   * Приглашение установить приложение, придержанное до загрузки оболочки.
   *
   * Глобальная переменная, а не импорт: забрать обработчик из
   * `useInstallPrompt` значило бы притащить сюда Vue и половину графа модулей —
   * ровно то, ради чего вход и разделён.
   */
  // eslint-disable-next-line no-var
  var tervikInstallEvent: Event | undefined
}

/**
 * Поймать приглашение браузера раньше оболочки.
 *
 * `beforeinstallprompt` приходит один раз и рано, а между этой строкой и
 * `initInstallPrompt` внутри оболочки теперь лежит сетевой запрос за её чанком.
 * Раньше слушатель вставал синхронно вместе со входом, и окна не было; с
 * динамическим импортом оно появилось, и приглашение, пришедшее в этот
 * промежуток, пропало бы молча — кнопка установки просто не нарисовалась бы.
 *
 * `preventDefault` здесь по той же причине, что и в оболочке: встроенная
 * плашка посреди работы — то же самое, что подменять приложение под руками
 * (ADR-0071).
 */
function holdInstallPrompt(): void {
  globalThis.addEventListener?.('beforeinstallprompt', (event) => {
    event.preventDefault()
    globalThis.tervikInstallEvent = event
  })
}

async function start(): Promise<void> {
  if (globalThis.tervikUnsupported) {
    console.warn(`[support] запуск отменён, не хватает: ${globalThis.tervikUnsupported}`)
    return
  }

  holdInstallPrompt()

  const { mountApp } = await import('./app/mount')
  await mountApp()
}

void start()
